// extracted by mini-css-extract-plugin
export var externalLink = "_b4-0";
export var internalLinkLabel = "_b4-1";